import $ from 'jquery';

const generateEmail = (data) => {
	const template = $('._template-block > .contact-mail').clone();

	template.find('#name').text(data.name);
	template.find('#tel').text(data.tel);
	template.find('#email').text(data.email);
	template.find('#category').text(data.category);
	template.find('#content').text(data.content);

	return `<head><meta charset='UTF-8'></head><body>${template.html()}</body>`;
};

export default generateEmail;



// WEBPACK FOOTER //
// ./src/js/about/generateEmail.js